import React, { Component } from 'react';

import { 
  FightingStyle
} from "@dndModels";

import API from "@utilities/smart_api";

import SelectBox from "@components/input/selects/SelectBox";
import LoadingBox from "@components/input/LoadingBox";

type Props = {
  name: string;
  value: string | null;
  multiple: boolean;
  values: string[];
  fighting_styles: FightingStyle[] | null;
  allow_all: boolean;
  allow_none: boolean;
  allow_any: boolean;
  color: string;
  onChange: Function;
}

export interface State {
  fighting_styles: FightingStyle[] | null;
  loading: boolean;
}

const api = API.getInstance();

class SelectFightingStyleBox extends Component<Props, State> {
  public static defaultProps = {
    fighting_styles: null,
    value: null,
    values: [],
    multiple: false,
    allow_all: false,
    allow_none: false,
    allow_any: false,
    color: "",
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      fighting_styles: null,
      loading: false
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({ loading: true }, () => {
      api.getObjects({data_type: "fighting_style"}).then(res => {
        this.setState({ fighting_styles: res as FightingStyle[], loading: false });
      });
    });
  }

  render() {
    if (this.state.loading || this.props.fighting_styles === null || this.state.fighting_styles === null) {
      return (<LoadingBox />);
    } else {
      const fighting_styles = this.props.fighting_styles === null ? this.state.fighting_styles : this.props.fighting_styles;
      if (fighting_styles) {
        if (this.props.multiple) {
          return (
            <SelectBox 
              options={fighting_styles}
              multiple
              allow_all={this.props.allow_all}
              allow_none={this.props.allow_none}
              allow_any={this.props.allow_any}
              values={this.props.values} 
              name={this.props.name}
              color={this.props.color}
              onChange={(ids: string[]) => {
                this.props.onChange(ids);
              }}
            />
          );
        } else {
          return (
            <SelectBox 
              options={fighting_styles}
              value={this.props.value} 
              name={this.props.name}
              allow_all={this.props.allow_all}
              allow_none={this.props.allow_none}
              allow_any={this.props.allow_any}
              color={this.props.color}
              onChange={(id: string) => {
                this.props.onChange(id);
              }}
            />
          );
        }
      } else {
        return null;
      }
    }
  }
}

export default SelectFightingStyleBox;
